import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_EDIT, CRUMB_LABEL_LIST, NAME } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';

export const router = new Path().addChildren([
	new Path(NAME, { List, SelectList: List }, CRUMB_LABEL_LIST),
	new Path(NAME, { Edit }, CRUMB_LABEL_EDIT),
]);
